// extracted by mini-css-extract-plugin
export default {"container":"micromag_container__2mh01","link":"micromag_link__2sxi-"};